module.exports = __webpack_public_path__ + "img/index-scan@3x.5531665a.png";